import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
var jssdkModule = {
  state: {
    // 当前是否已经缓存了jssdkParams
    _cacheJSSDKParams: false,
    // 服务器返回的jssdk参数数据
    jssdkParams: {},
    // 是否已经调用过jssdk.config
    jssdkConfig: false,
    // jssdk是否ready
    jssdkReady: false,
    // 所有等待中的ready回调
    jssdkReadyCallbacks: [],
    // jssdk是否error
    jssdkError: false,
    // 错误信息
    jssdkErrorRes: {},
    // 所有等待中的error回调
    jssdkErrorCallbacks: []
  },
  mutations: {
    /**
     * 标记jssdk参数是否经过了缓存
     *
     * @param {boolean} cache
     */
    // @ts-ignore
    cacheJSSDKParams: function cacheJSSDKParams(state, cache) {
      state._cacheJSSDKParams = cache;
    },

    /**
     * 设置jssdk参数
     *
     * @param {object} params
     */
    // @ts-ignore
    setJSSDKParams: function setJSSDKParams(state, params) {
      state.jssdkParams = params;
    },

    /**
     * 设置jssdk是否已经经过了wx.config
     *
     * @param {boolean} config 参数
     */
    // @ts-ignore
    setJSSDKConfig: function setJSSDKConfig(state, config) {
      state.jssdkConfig = config;
    },

    /**
     * 设置jssdk是否已经ready
     *
     * @param {boolean} ready
     */
    // @ts-ignore
    setJSSDKReady: function setJSSDKReady(state, ready) {
      state.jssdkReady = ready;
    },

    /**
     * 添加jssdk的ready回调
     *
     * @param {} cb 回调函数
     */
    // @ts-ignore
    addJSSDKReadyCallback: function addJSSDKReadyCallback(state, cb) {
      if (state.jssdkReady) {
        cb();
      } else {
        state.jssdkReadyCallbacks.push(cb);
      }
    },

    /**
     * 清空ready的callbacks
     */
    // @ts-ignore
    cleanJSSDKReadyCallbacks: function cleanJSSDKReadyCallbacks(state) {
      state.jssdkReadyCallbacks = [];
    },

    /**
     * 设置jssdk是否已经error
     *
     * @param {} error
     */
    // @ts-ignore
    setJSSDKError: function setJSSDKError(state, error) {
      state.jssdkError = error;
    },

    /**
     * 设置错误信息的res
     */
    // @ts-ignore
    setJSSDKErrorRes: function setJSSDKErrorRes(state, res) {
      state.jssdkErrorRes = res;
    },

    /**
     * 添加jssdk的error回到
     *
     * @param {} cb 回调函数
     */
    // @ts-ignore
    addJSSDKErrorCallback: function addJSSDKErrorCallback(state, cb) {
      if (state.jssdkError) {
        cb(state.jssdkErrorRes);
      } else {
        state.jssdkErrorCallbacks.push(cb);
      }
    },

    /**
     * 清空error的callbacks
     */
    // @ts-ignore
    cleanJSSDKErrorCallbacks: function cleanJSSDKErrorCallbacks(state) {
      state.jssdkErrorCallbacks = [];
    }
  }
};
var jssdk = {
  install: install,
  config: config,
  error: error,
  ready: ready
}; // 默认的options

var _options = null; // Vue对象

/**
 * 钩子函数
 */
// @ts-ignore

function config(param) {
  // @ts-ignore
  if (!jssdk.install.installed) {
    return;
  }

  if (!_options || !_options.store) {
    return;
  }

  var store = _options.store;
  var commit = store.commit;

  if (typeof wx === 'undefined') {
    var callbacks = store.state.jssdk.jssdkErrorCallbacks;
    commit('setJSSDKError', true);
    commit('setJSSDKErrorRes', {
      errMsg: '缺少wx'
    }); // @ts-ignore

    callbacks.forEach(function (cb) {
      cb && cb({
        errMsg: '缺少wx'
      });
    });
    commit('cleanJSSDKErrorCallbacks');
    return;
  } // 配置正确存在
  // if (store.state.jssdk.jssdkConfig) {
  //     return;
  // }


  window.wxstatus = 'unready';
  wx.config({
    // @ts-ignore
    beta: param.beta || false,
    debug: param.debug || false,
    appId: param.appId,
    // 必填，公众号的唯一标识
    timestamp: param.timestamp,
    // 必填，生成签名的时间戳
    nonceStr: param.nonceStr,
    // 必填，生成签名的随机串
    signature: param.signature,
    // 必填，签名，见附录1
    jsApiList: param.jsApiList,
    openTagList: param.openTagList
  });
  console.log('-----------------config---------------------', {
    // @ts-ignore
    beta: param.beta || false,
    debug: param.debug || false,
    appId: param.appId,
    // 必填，公众号的唯一标识
    timestamp: param.timestamp,
    // 必填，生成签名的时间戳
    nonceStr: param.nonceStr,
    // 必填，生成签名的随机串
    signature: param.signature,
    // 必填，签名，见附录1
    jsApiList: param.jsApiList,
    openTagList: param.openTagList
  });
  wx.ready(function () {
    console.log('我看看他执行不----------------------------'); // console.log(wx.config);

    var callbacks = store.state.jssdk.jssdkReadyCallbacks;
    commit('setJSSDKReady', true); // @ts-ignore

    callbacks.forEach(function (cb) {
      cb && cb();
    });
    commit('cleanJSSDKReadyCallbacks');
    window.wxstatus = 'ready';
  });
  wx.error(function (res) {
    var callbacks = store.state.jssdk.jssdkErrorCallbacks;
    commit('setJSSDKError', true);
    commit('setJSSDKErrorRes', res); // @ts-ignore

    callbacks.forEach(function (cb) {
      cb && cb(res);
    });
    commit('cleanJSSDKErrorCallbacks');
  }); // todo: 如果jssdk的config失败，但是该变量被设置成true，那么将不会再尝试jssdk的配置

  commit('setJSSDKConfig', true);
}
/**
 * Vue插件install函数
 *
 * @param {} Vue
 * @param {} options
 *  - store
 *  -
 */
// @ts-ignore


function install(Vue, options) {
  // 很想知道这里的install是什么
  // @ts-ignore
  if (install.installed) {
    return;
  } // @ts-ignore


  install.installed = true;

  if (!options.store) {
    return;
  }

  if (options.store.state.jssdk) {
    return;
  }

  _options = options; // 注册module

  options.store.registerModule('jssdk', jssdkModule);
}
/**
 * ready回调函数
 *
 * @param {} cb 回调函数
 */
// @ts-ignore


function ready(cb) {
  _options.store.commit('addJSSDKReadyCallback', cb);
}
/**
 * error回调函数
 *
 * @param {}
 */
// @ts-ignore


function error(cb) {
  _options.store.commit('addJSSDKErrorCallback', cb);
}

export default jssdk;